import React from 'react'

export default React.createContext({
  filtersData: {},
  updateFiltersData: (e) => {},
})
